/**
 * The Prospecting section (WEB-12804): one home for every prospecting tool.
 *
 * The whole section hangs off one soft-deploy flag, so a tab added later is
 * gated by being listed here - the navbar, the routes and the placeholder all
 * read this list. The tab names are working names and still open.
 */
export const PROSPECTING_TOOLS_FLAG = 'PROSPECTING_TOOLS';

export type ProspectingToolsTab = {
	key: 'findCompanies' | 'findNewProspects' | 'agent';
	path: string;
	/** The route's name, which is also its `react-root-*` Angular state. */
	name: string;
	langKey: string;
	/** A soft-deploy flag the tab needs on top of the section's: there is nothing in it without. */
	requires?: string;
};

export const PROSPECTING_TOOLS_TABS: ProspectingToolsTab[] = [
	// First, so the section lands here (WEB-13050).
	{
		key: 'findNewProspects',
		path: '/prospecting-workspace/find-new-prospects',
		name: 'prospectingToolsFindNewProspects',
		langKey: 'prospectingTools.tab.findNewProspects'
	},
	{
		key: 'findCompanies',
		path: '/prospecting-workspace/find-companies',
		name: 'prospectingToolsFindCompanies',
		langKey: 'prospectingTools.tab.findCompanies'
	},
	{
		// Engagement plans only since WEB-13131; the key and path stay so old links still resolve.
		key: 'agent',
		path: '/prospecting-workspace/agent',
		name: 'prospectingToolsAgent',
		langKey: 'prospectingTools.tab.agent',
		requires: 'OUTREACH_AGENT'
	}
	// Lookup and Enrichment were tabs until WEB-13187: Lookup is in supersearch's prospecting
	// section, Enrichment in Settings › Prospecting. Their old paths redirect (routes/index.tsx).
];
